import { Stack, Typography } from '@mui/material';

const PageHeader = ({ title, meta, children, actions }) => (
  <Stack
    sx={{
      bgcolor: 'background.paper',
      p: { xs: 1.5, sm: 2 },
      borderRadius: 1,
      boxShadow: 1,
      minHeight: 64,
      justifyContent: 'space-between',
      gap: 2.5,
    }}
  >
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1, minWidth: 0, flexWrap: 'wrap' }}>
      <Typography sx={{ fontSize: { xs: 18, sm: 20 }, fontWeight: 700, lineHeight: 1.3 }}>{title}</Typography>
      {meta !== undefined && meta !== null && meta !== '' && (
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{meta}</Typography>
      )}
    </Stack>

    {(children || actions) && (
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          gap: 1,
          minWidth: 0,
          '& > :first-of-type': { flex: 1, minWidth: 0 },
        }}
      >
        {children}
        {actions && (
          <Stack direction="row" sx={{ alignItems: 'center', gap: 1, flexShrink: 0, flexWrap: 'wrap' }}>
            {actions}
          </Stack>
        )}
      </Stack>
    )}
  </Stack>
);

export default PageHeader;
